<template>
<article class="custom-funds-wrapper">
  <notification />
  <section class="custom-funds-section">
    <header-simple :title="title" />
    <div class="custom-funds-container">
      <p class="fund-instruction-text">
        This feature enables the users to create custom funds in Connect. To Create custom funds
         you need to select universe and category from the dropdown menu and enter the fund name and then hit on create.
      </p>
      <div class="custom-fund-form-container">
        <mds-form class="custom-fund-form">
          <mds-combo-box
          class="custom-fund-category-dropdown"
          label="Select The Universe and Category:"
          v-model="selectedCategory"
          :data-set="fundCategoryOptions"
          placeholder="Select an Option"
          ></mds-combo-box>
          <mds-input
          class="custom-fund-name"
          label="Enter Fund Name"
          v-model.trim="customFundName"
          ></mds-input>
          <mds-button
            class="create-fund-button"
            variation="primary"
            :disabled="disableCreateFund"
            @click.prevent="createNewFund"
          >
          Create
          </mds-button>
        </mds-form>
      </div>
      <div class="custom-fund-table-container"
        :class="{'custom-fund-empty-container empty-state' : customFundData.length === 0}"
      >
        <loader-spinner v-show="showLoader"/>
        <div v-show="!showLoader">
          <div class="custom-fund-table" v-show="customFundData.length > 0">
          <div class="custom-fund-table-heading">Fund Created in Database</div>
            <DataTable
              :columnsConfig="columnsConfig"
              :data="customFundData"
              class="table-container fixed-header-table"
            ></DataTable>
          </div>
          <div v-show="customFundData.length === 0">
            There is no fund added
          </div>
        </div>
      </div>
      <div class="back-navigation-container">
        <mds-button class="back-button" variation="flat" icon="caret-left" type="button" @click="gotoPrevScreen()">
          Back
        </mds-button>
      </div>
    </div>
  </section>
</article>
</template>

<script>
import HeaderSimple from '@/components/atoms/HeaderSimple';
import MdsForm from '@mds/form';
import MdsComboBox from '@mds/combo-box';
import MdsInput from '@mds/input';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';
import { goToLogoutRoute, goToRoute } from '@/utils';
import Notification from '@/components/atoms/Notification';
import DataTable from '@/components/molecules/data-table/table';
import { getCategoryForFund, createNewCustomFund } from '../services/CustomFunds';

const columnsConfig = require('@/config/custom-fund-columns.json');

const INITIAL_FUND_NAME_VALUE = '';
const INITIAL_FUND_TYPE_VALUE = [];

export default {

  name: 'CreateCustomFunds',
  components: {
    HeaderSimple,
    MdsForm,
    MdsComboBox,
    MdsInput,
    DataTable,
    Notification,
    LoaderSpinner,
  },
  data() {
    return {
      title: 'Create custom Funds',
      columnsConfig,
      fundCategoryOptions: [],
      selectedCategory: INITIAL_FUND_TYPE_VALUE,
      customFundName: INITIAL_FUND_NAME_VALUE,
      customFundData: [],
      showLoader: false,
    };
  },
  computed: {
    disableCreateFund() {
      return !this.customFundName || this.selectedCategory.length === 0;
    },
  },
  created() {
    this.loadFundsOption();
  },
  methods: {
    loadFundsOption() {
      getCategoryForFund().then((response) => {
        const { data } = response;
        this.fundCategoryOptions = data.list.map((item) => {
          return {
            text: item.category,
            value: item.category,
          };
        });
      }).catch((error) => {
        this.handleError(error);
      });
    },
    createNewFund() {
      const customFundRequest = {
        universeCategory: this.selectedCategory[0],
        standardName: this.customFundName,
      };
      this.showLoader = true;
      createNewCustomFund(customFundRequest).then((response) => {
        const { data } = response;
        this.showLoader = false;
        this.customFundData = data.list;
        this.resetFields();
        this.$store.dispatch('openNotification', {
          // eslint-disable-next-line max-len
          message: 'You\'ve created a new custom fund in the database, <span class="notification-highlight">please write down the SecID!!!</span>',
        });
      }).catch((error) => {
        this.handleError(error);
      });
    },
    handleError(error) {
      const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
      if (httpStatus === 401) {
        goToLogoutRoute();
      }
    },
    resetFields() {
      this.selectedCategory = INITIAL_FUND_TYPE_VALUE;
      this.customFundName = INITIAL_FUND_NAME_VALUE;
    },
    closeNotification() {
      this.$store.dispatch('closeNotification');
    },
    gotoPrevScreen() {
      goToRoute(this.$route, this.$router, '/');
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeNotification();
    next();
  },
};
</script>
<style lang="scss">
.custom-funds-section {
  display: flex;
  flex-direction: column;
}
.fund-instruction-text {
  @include mds-level-6-heading();
}
.custom-funds-container {
  padding: $mds-space-4-x;
}
.custom-fund-form-container{
  margin-top: $mds-space-4-x;
}
.custom-fund-form {
  display: flex;
  align-items: flex-end;

  .custom-fund-category-dropdown {
    width: 250px;
  }
  .custom-fund-name {
    width: 500px;
    margin-left: 20px;
  }
  .create-fund-button {
    margin: 0 0 20px 15px;
  }
}
.custom-fund-table-container {
  margin: 40px 0 20px 0;
  padding: 30px 25px;
  border-radius: 6px;
  min-height: 120px;
  border: 1px solid $mds-color-neutral-80;
}
.custom-fund-table {
  .fixed-header-table .mds-data-table__header th {
    z-index: 10;
  }
}
.custom-fund-table-heading {
  margin-bottom: 30px;
  @include mds-level-5-heading();
}
.custom-fund-empty-container {
  background-color:#F2F2F2;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-m;
}
.notification-highlight {
  font-weight: bold;
}
</style>
